import { login } from '../../utils/authenticate';
import { WEB_LOGIN, WEB_LOGOUT, CLEAR_STATE_DATA, SET_ORDER_TYPES, SET_TABLE_ORDERS } from '../action-types/session-actions';
import { get_order_type, get_table_orders } from '../../utils/order_helper';
import { preload_menu_data, set_order_type } from './action';
import { ORDER_CODE, TOKEN_KEY } from '../../utils/constant';

export const WebLogin = ({ store_id, location_id }) => {
    return async (dispatch) => {
        dispatch({ type: WEB_LOGOUT });
        dispatch({ type: CLEAR_STATE_DATA });
        try { localStorage.removeItem(TOKEN_KEY); } catch (e) {}

        console.log('[WebLogin] start', { store_id, location_id });
        const resp = await login({ store_id, location_id: location_id || '' });
        console.log('[WebLogin] login resp', {
            isAuthented: resp?.isAuthented,
            user: resp?.user,
            store_id_from_store: resp?.store?.store_id,
            has_storeConfig: !!resp?.storeConfig,
            associated_store_qr: resp?.storeConfig?.web_ordering_setting?.associated_store_qr,
            is_multi_store_qr: resp?.storeConfig?.web_ordering_setting?.is_multi_store_qr,
        });
        if (!resp || !resp.isAuthented) return false;

        const token = resp.user?.token;
        const loginLocationId = resp.user?.location_id;
        const apiTable = resp.table_details;
        const hasTableDetails = apiTable && Object.keys(apiTable).length > 0;
        const isMenuOnly = resp.storeConfig?.web_ordering_setting?.is_menu === true;
        const isFSR = !isMenuOnly && hasTableDetails;

        let tentId = null;
        if (loginLocationId && !["di", "ta", "takeaway", "dinein"].includes(loginLocationId.toLowerCase()) && !isNaN(Number(loginLocationId))) {
            tentId = loginLocationId;
        }

        const associatedDetails = Array.isArray(resp.associated_details) ? resp.associated_details : [];
        console.log('[WebLogin] associated_details from API', {
            count: associatedDetails.length,
            ids: associatedDetails.map((s) => s?.store_id),
        });

        dispatch({
            type: WEB_LOGIN,
            payload: {
                token,
                store_id: resp.user?.store_id,
                location_id: loginLocationId,
                tent_id: tentId,
                table_details: isFSR ? apiTable : null,
                store_details: resp.store || null,
                store_config: resp.storeConfig || null,
                is_fsr: isFSR,
                associated_stores: associatedDetails,
            },
        });

        if (isFSR && apiTable?.table_id) {
            try {
                const s_id = resp.user?.store_id || store_id;
                const b_date = resp.store?.business_date || "";

                const tableOrdersInput = {
                    store_id: s_id,
                    table_id: String(apiTable.table_id),
                    business_date: b_date,
                };
                console.log('[WebLogin] fetching table orders', tableOrdersInput);
                const tableOrders = await get_table_orders(tableOrdersInput);
                if (tableOrders) {
                    dispatch({ type: SET_TABLE_ORDERS, table_orders: tableOrders });

                    const ordersArray = Array.isArray(tableOrders)
                        ? tableOrders
                        : (tableOrders?.data || []);

                    const tableId = String(apiTable.table_id);
                    const businessDate = b_date ? b_date.slice(0, 10) : "";

                    const openOrder = ordersArray
                        .filter((o) => {
                            const orderTableId = String(o?.store_details?.table_id || o?.table_id || "");
                            if (orderTableId !== tableId) return false;
                            const status = (o?.order_status || "").toUpperCase();
                            if (status !== "OPEN") return false;
                            if (businessDate) {
                                const orderDate = (o?.business_date || o?.date_time || "").slice(0, 10);
                                if (orderDate && orderDate !== businessDate) return false;
                            }
                            return true;
                        })
                        .sort((a, b) => {
                            const timeA = new Date(a?.date_time || a?.updated_at || a?.order_end_date_time || a?.created_at || 0).getTime();
                            const timeB = new Date(b?.date_time || b?.updated_at || b?.order_end_date_time || b?.created_at || 0).getTime();
                            return timeB - timeA;
                        })[0] || null;

                    if (openOrder) {
                        const cacheKey = tableId;
                        console.log('[WebLogin] populating active_table_orders', {
                            cacheKey,
                            invoice_no: openOrder?.invoice_no,
                            order_no: openOrder?.order_no,
                            offline_invoice_no: openOrder?.offline_invoice_no,
                        });
                        dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { order: openOrder } } });
                        dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { items: openOrder.item_details } } });
                        dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { payBillEnabled: true } } });
                        dispatch({ type: 'SET_OFFLINE_INVOICE_NO', offline_invoice_no: openOrder?.offline_invoice_no || null });
                    }
                }
            } catch (e) {
                console.error('[WebLogin] error fetching table orders', e);
            }
        }

        // Transitional bridge: legacy API helpers in store_helper.js / item_helper.js /
        // order_helper.js still read token+store_id from localStorage[TOKEN_KEY].
        // Mirror the Redux session into the legacy shape until those helpers are
        // migrated to accept args from callers (tracked in project_fsr_migration_pending.md).
        

        // is_menu = pure display menu, no ordering. Skip order-type fetch and
        // auto-pick; just preload the catalog so something renders.
        if (isMenuOnly) {
            await dispatch(preload_menu_data());
            return true;
        }

        console.log('[WebLogin] calling get_order_type', { has_token: !!token, store_id });
        const orderTypes = await get_order_type({ token, store_id });
        console.log('[WebLogin] get_order_type result', {
            is_array: Array.isArray(orderTypes),
            length: orderTypes?.length,
            codes: orderTypes?.map((o) => o?.order_code),
        });
        if (orderTypes) {
            dispatch({ type: SET_ORDER_TYPES, order_types: orderTypes });
        }

        // FSR scan tells us TA vs DI from location_id, so skip the tile UI.
        // QSR users still pick manually on Home.
        if ((isFSR || tentId) && Array.isArray(orderTypes)) {
            const loc = (loginLocationId || "").toLowerCase();
            const matched = orderTypes.find((e) =>
                loc === ORDER_CODE.TAKE_AWAY.toLowerCase()
                    ? e.order_code === ORDER_CODE.TAKE_AWAY
                    : e.order_code === ORDER_CODE.DINE_IN
            );
            if (matched) dispatch(set_order_type({ order: matched }));
        }

        console.log('[WebLogin] awaiting preload_menu_data');
        await dispatch(preload_menu_data());

        return true;
    };
};

export const WebLogout = () => {
    return (dispatch) => {
        try { localStorage.removeItem(TOKEN_KEY); } catch (e) {}
        dispatch({ type: WEB_LOGOUT });
        dispatch({ type: CLEAR_STATE_DATA });
    };
};
